import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('expenseSubmissions', app)
  return store
}
